import { AxiosInstance } from "axios";
import { IBaseEntubaBPRequest } from "src/services/interface/entuba/business-partner/request/IBaseEntubaBPRequest";
import { IEntubaBPResponse } from "src/services/interface/entuba/business-partner/response/entubaResponse";
import { IEntubaOCRDetailResponse, IEntubaOCRRecord } from "src/services/interface/entuba/OCR/IEntubaOCRDetailResponse";
import { ICreateBpLeadRecord } from "src/services/interface/lead/ICreateBpLeadRecord";
import { ISimulationLeadRequest } from "src/services/interface/lead/ISimulationLeadRequest";
import { ApiService } from "src/services/model/Api.model";

enum BPEntubaLeadsServiceEnum {
    start = "/start",
    getAll = "/",
    getDetail = "/detail",
    getDetailByEntubaId = "/detail-by-entuba-id",
    updateProposal = "/record-update",
    getAllRecords = "/records/",
    getDetailByEntubaRecordId = "/detail-by-record-id",
    formalizeRecord = "/record-formalize",
    startRecord = "/start/record",
    simulate = "/simulate",
    bpEntubaRecordByEntubaId = "/bpEntubaRecordByEntubaId"
}

export default class BPEntubaLeadsService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/bp/entuba/leads");
    }

    public start = async (request: IBaseEntubaBPRequest): Promise<IEntubaBPResponse> => await this.POST(BPEntubaLeadsServiceEnum.start, request);
    public simulate = async (request: ISimulationLeadRequest): Promise<any> => await this.POST(BPEntubaLeadsServiceEnum.simulate, request);
    public startRecord = async (request: ICreateBpLeadRecord): Promise<IEntubaBPResponse> => await this.POST(BPEntubaLeadsServiceEnum.startRecord, request);
    public getAll = async (): Promise<any> => await this.GET(BPEntubaLeadsServiceEnum.getAll);
    public getAllRecords = async (starDate, endDate): Promise<IEntubaOCRRecord[]> => await this.GET(BPEntubaLeadsServiceEnum.getAllRecords + `?startDate=${starDate}&endDate=${endDate}`);
    public getDetail = async (id: number): Promise<IEntubaOCRDetailResponse> => await this.GET(`${BPEntubaLeadsServiceEnum.getDetail}/${id}`);
    public getDetailByEntubaId = async (entubaId: number): Promise<IEntubaOCRRecord> => await this.GET(`${BPEntubaLeadsServiceEnum.getDetailByEntubaId}/${entubaId}`);
    public updateProposal = async (request: any): Promise<IEntubaBPResponse> => await this.PUT(BPEntubaLeadsServiceEnum.updateProposal, request);
    public getDetailByEntubaRecordId = async (entubaId: number): Promise<IEntubaOCRRecord> => await this.GET(`${BPEntubaLeadsServiceEnum.getDetailByEntubaRecordId}/${entubaId}`);
    public formalizeRecord = async (request: any): Promise<any> => await this.POST(BPEntubaLeadsServiceEnum.formalizeRecord, request);
    public GetEntubaRecordByEntubaId = async (entubaId: number): Promise<any> => await this.GET(`${BPEntubaLeadsServiceEnum.bpEntubaRecordByEntubaId}/${entubaId}`);
}


// WEBPACK FOOTER //
// ./src/services/api/BusinessPartner/entuba/leads/entuba-leads.service.ts